import { ProjectActivityDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectActivityService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProjectActivity(): Observable<ProjectActivityDto[]> {
    return this.http.get<ProjectActivityDto[]>(this.url + 'project-activity');
  }

  createProjectActivity(
    data: ProjectActivityDto[]
  ): Observable<ProjectActivityDto[]> {
    return this.http.post<ProjectActivityDto[]>(
      this.url + 'project-activity',
      data
    );
  }
  getSingleProjectActivity(id: string): Observable<any> {
    return this.http.get(this.url + 'project-activity/' + id);
  }

  updateProjectActivity(
    data: ProjectActivityDto[]
  ): Observable<ProjectActivityDto[]> {
    return this.http.post<ProjectActivityDto[]>(
      this.url + 'project-activity/update',
      data
    );
  }

  deleteProjectActivity(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-activity', ids.join(', '));
    return this.http.delete(this.url + 'project-activity', httpOptions);
  }
}
